import { staffConversationContextSchema, staffConversationJoinResultSchema, } from "@lafayette/schemas";
import { createMemoryTransport, } from "./memory-transport";
const contextPath = (conversationId) => `/staff/conversations/${encodeURIComponent(conversationId)}/context`;
const joinPath = (conversationId) => `/staff/conversations/${encodeURIComponent(conversationId)}/join`;
export function createStaffConversationContextApi(options) {
    const send = createMemoryTransport(options);
    return {
        getContext: (conversationId, callOptions) => send({
            method: "GET",
            path: contextPath(conversationId),
            schema: staffConversationContextSchema,
            signal: callOptions?.signal,
        }),
        join: (conversationId, callOptions) => send({
            method: "POST",
            path: joinPath(conversationId),
            schema: staffConversationJoinResultSchema,
            signal: callOptions?.signal,
        }),
    };
}
